import { useEffect, useMemo } from 'react'
import { Row, useTable } from 'react-table'
import { KTCardBody } from '../../../../../../_metronic/helpers'
import { Application, ApplicationReview } from '../../_models'
import { CustomRow } from './components'

import { ApplicationReviewUserColumns, ApplicationReviewApplicantColumns }from './columns'

import { orderBy } from 'lodash'
import { useAuth } from '../../../../auth'
import { isPopulatedArray } from '../../../../../components/helpers'
import { SubmitInspectionModal } from '../../../../setsco/workflow/submit-inspection-modal/SubmitInspectionModal'
import { SubmitReassignModal } from '../../../../setsco/workflow/submit-reassign-modal/SubmitReassignModal'
import { useApplicationReviewState, useApplicationReviewTableState } from './components/_store'
import { PropsWithNotes, TableHead } from '../../../../../components/table'
import { ViewDraftPopup } from '../../../../setsco/workflow/components/ViewDraftPopup'
import { useQueryClient } from 'react-query'

type Props = {
  appData: Application  
}

export const ApplicationReviewTable = ({appData} : Props) => {
  
  const { currentUser } = useAuth();
  const queryClient = useQueryClient();

  const { show_inspect, show_reassign, reviewId, clear: closeModals } = useApplicationReviewState(state => state);
  const { data, setData } = useApplicationReviewTableState(state => state);

  const invalidateAppData = async () => {
    await queryClient.invalidateQueries(['GETAPPLICATION', `${appData.id}`]);
  }
 
  const reviews: Array<PropsWithNotes<ApplicationReview>> = useMemo(() => {
    if (! (appData && appData?.applicationReviews && isPopulatedArray(appData.applicationReviews))) {
      return [];
    }
    return orderBy(appData?.applicationReviews, ['type','id'], ['asc','asc']).map(o => ({...o, showNotes: true}));    
  }, [appData])

  const columns = useMemo(() => {
    return (currentUser && currentUser.isSetsco) ? ApplicationReviewUserColumns : ApplicationReviewApplicantColumns;
  } , [currentUser]);
  
  const {getTableProps, getTableBodyProps, headerGroups, rows, prepareRow} = useTable({    
    columns,
    data
  })

  useEffect(() => {
    setData(reviews ? reviews: []);
  // eslint-disable-next-line
  }, [reviews])
      
  return (
  <>
  <KTCardBody className='py-4'>
    <div className='table-responsive'>
      <table
        id='kt_table_dlm_labelling'
        className='table align-middle table-row-bordered table-row-gray-300 fs-7 gy-2 dataTable no-footer'
        {...getTableProps()}
      >
        <TableHead {...{headerGroups}} />        
        <tbody className='text-gray-800 fs-7' {...getTableBodyProps()}>
          {(rows && rows.length > 0) &&
          rows.map((row: Row<PropsWithNotes<ApplicationReview>>, i) => {
            prepareRow(row)
            return <CustomRow row={row} key={`row-${i}-${row.id}`} />
          })
          }
        </tbody>
      </table>
    </div>    
  </KTCardBody>
  {show_inspect &&
  <SubmitInspectionModal
    appData={appData}  
    reviewId={reviewId}
    draftVars={{}}
    doClose={async() => {
      closeModals();
      await invalidateAppData();
    }}
  />
  }
  {show_reassign &&
  <SubmitReassignModal
    appData={appData}
    reviewId={reviewId}
    doClose={async() => {
      closeModals();
      await invalidateAppData();
    }}
  />
  }
  <ViewDraftPopup />
  </>
  )
}